import { Form } from 'antd';
import styled from 'styled-components';

import { media } from '@/shared/components';

export const InterwillFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;

  width: 100%;
  max-width: 100%;

  row-gap: 16px;

  ${media.desktop} {
    padding-right: 12px;
    padding-left: 2px;
    padding-bottom: 24px;
  }

  ${media.mobile} {
    max-height: 100%;
    padding-left: 2px;
    padding-right: 2px;
    padding-bottom: 16px;
  }
`;

export const InterwillStyledForm = styled(Form)`
  display: flex;
  flex-direction: column;
  overflow: hidden;

  width: 100%;
  max-width: 100%;
  padding: 24px !important;

  ${media.mobile} {
    padding: 0px 16px 16px !important;
  }
`;

export const InterwillSubmitButtonWrapper = styled.div`
  display: flex;
  padding-top: 16px;

  ${media.desktop} {
    justify-content: flex-end;
  }
`;

export const InterwillFieldsLineWrapper = styled.div`
  display: flex;
  gap: 16px;

  ${media.mobile} {
    flex-direction: column;
  }
`;
